export const BILLS_FETCH_ALL = 'BILLS_FETCH_ALL';
export const BILLS_FETCH_BILL = 'BILLS_FETCH_BILL';
